// The slate-blue ramp every Votely slider fills with: #93a8d1 at the light
// end, #3b5998 at the deep end. Extracted from quiz-page-client so the quiz
// and the results-page satisfaction slider cannot drift apart.
const LIGHT = { r: 147, g: 168, b: 209 }; // #93a8d1, --color-slider-light
const DEEP = { r: 59, g: 89, b: 152 };    // #3b5998, --color-slider

/** `intensity` runs 0 (lightest) to 1 (deepest). */
export function sliderColorAt(intensity: number): string {
  const t = Math.min(1, Math.max(0, intensity));
  const c = (a: number, b: number) => Math.round(a - (a - b) * t);
  return `rgb(${c(LIGHT.r, DEEP.r)} ${c(LIGHT.g, DEEP.g)} ${c(LIGHT.b, DEEP.b)})`;
}

/**
 * Quiz sliders are bipolar: 0.5 is neutral and the colour deepens as an
 * answer moves away from the centre in either direction.
 */
export const getSliderColor = (value: number): string =>
  sliderColorAt(Math.abs(value - 0.5) * 2);
